module.exports = __webpack_public_path__ + "static/media/0022_LES_ENSEIGNES_LE_TRAITEUR_SCRABBLE.ce60b6c6.png";